// Détection d'appareil tactile : décide si on affiche les contrôles tactiles (joystick + bouton).
// `?touch=1` dans l'URL force l'affichage (QA sur desktop), sinon on teste les capacités du device.
export function isTouchDevice(): boolean {
    if (typeof window === 'undefined') return false
    try {
        const forced = new URLSearchParams(window.location.search).get('touch')
        if (forced === '1') return true
        if (forced === '0') return false
    } catch {
        // location indisponible : on retombe sur la détection de capacités.
    }
    return (
        (typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches) ||
        'ontouchstart' in window ||
        (typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0)
    )
}
